/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'list': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M40 212.8a4.2 4.2 0 10134.4 0 4.2 4.2 0 10-134.4 0zM980.8 145.6H297.6c-9.6 0-16 8-16 16V264c0 9.6 8 16 16 16h683.2c9.6 0 16-8 16-16V161.6c0-9.6-8-16-16-16zM28.799999999999997 497.6a4.2 4.2 0 10134.4 0 4.2 4.2 0 10-134.4 0zM968 430.4H284.8c-9.6 0-16 8-16 16v102.4c0 9.6 8 16 16 16H968c9.6 0 16-8 16-16V446.4c0-8-6.4-16-16-16zM28.799999999999997 795.2a4.2 4.2 0 10134.4 0 4.2 4.2 0 10-134.4 0zM968 728H284.8c-9.6 0-16 8-16 16v102.4c0 9.6 8 16 16 16H968c9.6 0 16-8 16-16V744c0-8-6.4-16-16-16z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/list.js